<template>
	<div class="messages">
		<div class="row">
			<div class="col-5 mb-4">
				<h1>{{ `${$t('patient-feedback-for')}  ${isAuthorised ? studentName : null}` }}</h1>
			</div>
			<!--
			<div class="col-12 d-lg-none mb-4">
				<input
					type="search"
					:placeholder="$t('search-messages-ellipses')"
					class="block w-full form-control"
					:value="searchTerm"
					@input="searchTerm = $event.target.value"
					@keyup="searchTermChange"
					@search="searchTermChange"
				/>
			</div>
			-->
		</div>


		<InfiniteScroll
			type="TreatmentSessionPatientFeedback"
			:dataUrl="`${this.$settings.APIBaseURL}/treatmentsessions/patientfeedback/listfeedback`"
			dataProperty="feedback"
			class="inspector-list full-width"
			itemClass="inspector-list-item"
			@selectItem="selectFeedback"
			ref="infinitescroll"
			:lookaheadPx="50"
			idProperty="treatmentsession_id"
			:noResultsText="$t('no-results')"
			scrollElementId="main"
		/>

		<div class="inspector-list-detail active" v-if="selectedFeedback" ref="selectedFeedbackDiv"><div class="float-right">
				<router-link
					:to="`/clinical/treatmentsession/${selectedFeedback.treatmentsession_id}`"
					class="btn btn-light btn-xs ml-3 pl-2 pr-2"
                    v-if="this.$UserSession.hasPriv.call(this,'MYTREATMENTSESSIONFEEDBACK_IDENTIFY')"
				>
					{{$t("treatment-session")}}
				</router-link>
				<a
					class="btn btn-light btn-xs ml-3"
					v-on:click="closeView()"
					><b-icon icon="x" width="1em" height="1em"></b-icon>
				</a>
			</div>
			<h2><strong>
                {{
                    showDate(selectedFeedback.treatmentsession_dateoftreatment)
                }}
            </strong></h2>
			<hr>
			<template v-for="response in selectedFeedback.responses">
				<div :key="response.response_id" class="pt-0 pb-0">
					<p class="mb-1 mt-0" style="white-space: pre">{{response.question_text}}</p>
					<div
						class="badge badge-pill badge-primary mb-2"
						:class="{
							'badge-primary': response.response_type == 0,
							'badge-danger': response.response_type == -1,
							'badge-success': response.response_type == 1,
							'btn-emoji': response.response_emoji
						}"
					>{{ response.response_emoji ? String.fromCodePoint(response.response_emoji) : response.response_text}}</div>
					<hr>
				</div>
			</template>

		</div>
	</div>
</template>

<script>
import InfiniteScroll from "src/components/InfiniteScroll";

export default {
	components: {
		InfiniteScroll
	},
	data() {
		return {
			selectedFeedback: null,
			search: {
				q: ""
			},
            students: [],
            studentName: ''
		};
	},
	mounted() {

		this.setSearchDefaults();
		this.getFeedback();
        this.getStudentName();

	},
	methods: {
		setSearchDefaults(){
			this.search = {
				q: "",
				teacher: this.isNotStudent ? this.$UserSession.getValue.call(this, "id") : null
			};
		},
		getFeedback() {
			let body = {
				q: this.search.q ,
				student_id:  
                this.isAuthorised && this.studentId ? 
                this.studentId : null
			};
			this.$refs.infinitescroll.getData("replace", body);
		},
		selectFeedback(feedback) {
			this.selectedFeedback = feedback;
			this.$nextTick(function() {
				this.$refs.selectedFeedbackDiv.scroll({top:0});
			});
		},
		closeView() {
			this.selectedFeedback = null;
		},
		searchTermChange() {
			if (this.searchTimer) {
				clearTimeout(this.searchTimer);
			}
			this.searchTimer = setTimeout(() => {
				this.getFormResponses();
			}, 500);
		},
        showDate(date) {
        	if(this.$UserSession.hasPriv.call(this,'MYTREATMENTSESSIONFEEDBACK_IDENTIFY')){
        		return this.$datetime.getLocaleStringFromTimeStamp(date)
        	} else {
				return this.$datetime.getMonthYearStringFromTimestamp(date)
			}
        },
        getStudentName(){
            if(!this.studentId)
            {
                this.studentName = this.$t('unknown');
                return ;
            }

            if(this.$UserSession.getValue('id'))

            return this.$users.getUserById.call(this,this.studentId).
            then((u) => this.studentName = u.displayName)
        }
	},
    computed: {
        isNotStudent(){
            return this.$UserSession.hasPriv.call(this, 'APP_ALLSTUDENTS');
        },
        studentId(){
            if(this.$route.params.studentid) return this.$route.params.studentid;
            return this.$UserSession.getValue.call(this, "id")
        },
        isAuthorised(){
            return this.$UserSession.hasPriv.call(this, 'APP_ALLSTUDENTS') 
            || ( 
                this.$UserSession.hasPriv.call(this, 'VIEW_PATIENTFEEDBACKFORSTUDENT') 
                && (
                    this.$route.params.studentid === this.$UserSession.getValue.call(this, "id")
                    || !this.$route.params.studentid 
                )
            )
        }
       
    }
};
</script>
